import React, { Component } from 'react';
import '@styles/public/home/slideShow.scss'; 
import { Carousel } from '@components/public/shared/Carousel';

export class SlideShow extends Component {
    static displayName = SlideShow.name;

    constructor(props) {
        super(props);

        this.state = {
            screenWidth: window.innerWidth
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.UpdateScreenWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.UpdateScreenWidth);
    }

    UpdateScreenWidth = () => {
        this.setState((prevState) => ({ ...prevState, screenWidth: window.innerWidth }));
    };

    GetImageExtension = (img) => {
        let split = img.split(".");
        return split[split.length - 1];
    }
   
    GetSlides = () => {
        return this.props.slides.map((slide, i) => ({
            element: (
                <React.Fragment key={i}>
                    <figure className='slide w-100 h-100 m-0'>
                        <picture>
                            {slide.imgMobile.length > 0 &&
                                <source srcSet={`files/images/${slide.imgMobile}`} media="(min-width: 0px) and (max-width: 576px)" type={`image/${this.GetImageExtension(slide.imgMobile)}`} />
                            }
                            {slide.imgTablet.length > 0 &&
                                <source srcSet={`files/images/${slide.imgTablet}`} media="(min-width: 577px) and (max-width: 1200px)" type={`image/${this.GetImageExtension(slide.imgTablet)}`} />
                            }
                            {slide.imgPc.length > 0 &&
                                <source srcSet={`files/images/${slide.imgPc}`} media="(min-width: 1201px) and (max-width: 1920px)" type={`image/${this.GetImageExtension(slide.imgPc)}`} />
                            }
                            {slide.imgPcLarge.length > 0 &&
                                <source srcSet={`files/images/${slide.imgPcLarge}`} media="(min-width: 1921px)" type={`image/${this.GetImageExtension(slide.imgPcLarge)}`} />
                            }
                            <img src={`files/images/${slide.imgPc}`} alt={
                                !this.props.translate ?
                                    slide.text
                                    :
                                    this.props.translate(slide.text, true)
                            } />
                        </picture>
                    </figure>

                    <div className='caption position-absolute pe-3' style={{ color: slide.fontColor, top: ((this.state.screenWidth <= 576 || this.props.forceMobile) ? slide.captionMobileY : slide.captionY), left: ((this.state.screenWidth <= 576 || this.props.forceMobile) ? slide.captionMobileX : slide.captionX) }}>
                        <div className='heading' style={{ color: slide.fontColor }}>
                            {!this.props.translate ?
                                slide.heading
                                :
                                this.props.translate(slide.heading)
                            }
                        </div>
                        <div className='text' style={{ color: slide.fontColor }}>
                            {!this.props.translate ?
                                slide.text
                                :
                                this.props.translate(slide.text)
                            }
                        </div>
                    </div>
                </React.Fragment>
            ),
            duration: slide.duration
        }))
    }
    
    render() {
        return (
            this.props.slides.length > 0 &&
                <section id='slideShow'
                    className={`${this.props.forceMobile ? 'forceMobile' : ''} position-relative w-100 m-0 p-0`}
                >
                    <Carousel
                        slides={this.GetSlides()}
                        forceMobile={this.props.forceMobile}
                        forceShowControls={this.props.forceShowControls}
                    />
                </section>
        );
    }
}
